const defaultProps = {
	value: '',
};

export default defaultProps;
